// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.svgbtn[data-v-df046976]\n{\n\tborder: 1px solid #000000;\n\tpadding: 1px;\n\tbox-sizing: border-box;\n\tcursor: pointer;\n}\n.svgbtn[data-v-df046976]:hover\n\t{\n\t\tbackground-color: rgba(0,0,0,0.05);\n}\n.svgbtn[data-v-df046976]:active\n\t{\n\t\tbackground-color: rgba(0,0,0,0.085);\n}\n", ""]);
// Exports
module.exports = exports;
